module.exports = __webpack_public_path__ + "static/media/foreldre.ee428369.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/HomePage/static/foreldre.png
// module id = 148
// module chunks = 0